/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var JewelDiamondIcon16Solid = forwardRef('JewelDiamondIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.022 2H4.245a1.75 1.75 0 0 0-1.391.688L.614 5.62a1.75 1.75 0 0 0-.22.38h3.482l2.146-4Z" }),
        React.createElement("path", { d: "M3.886 7.25H.35c.079.23.206.446.382.632l6.358 6.746a1.25 1.25 0 0 0 1.82 0l6.358-6.746c.176-.186.303-.402.382-.632h-3.536l-3.57 6.308a.625.625 0 0 1-1.088 0L3.886 7.25Z" }),
        React.createElement("path", { d: "M10.678 7.25 8 11.981 5.322 7.25h5.356Z" }),
        React.createElement("path", { d: "M10.705 6h-5.41L7.44 2h1.118l2.146 4Z" }),
        React.createElement("path", { d: "M12.124 6h3.482a1.75 1.75 0 0 0-.22-.38l-2.24-2.932A1.75 1.75 0 0 0 11.756 2H9.977l2.146 4Z" })));
});
